/**
 * This dropdown is used in the Change Story post type archive
 */
export default {
  init: function () {
    if (!$('#tagsDropdown').length) {
      return;
    }

    $("#storyTopicDropdown").on('click', this.toggleDropdown);

    $(document.body).on('click', () => {
      $("#tagsDropdown").removeClass('show');
      $("#tagsDropdown .dropdown-menu").removeClass('show');
    });

    this.changeDropDown();
  },
  toggleDropdown: function(e) {
    $("#tagsDropdown").toggleClass('show');
    $("#tagsDropdown .dropdown-menu").toggleClass('show');
    $("#tagsDropdown .dropdown-menu").removeAttr('style');
    e.preventDefault();
    return false;
  },
  changeDropDown: function () {
    var params = new URLSearchParams(window.location.search);

    if (params.has('story_tag')) {
      var storyTag = params.get('story_tag');
      $('#tagsDropdown .active').removeClass('active');

      var activeListItem = $('#tagsDropdown .dropdown-menu .dropdown__link.' + storyTag);

      $(activeListItem).addClass('active');

      var tagName = $(activeListItem).text();

      $('#storyTopicDropdown .text').text(tagName);
    }
  }

}
